import intl from "react-intl-universal";
import { EmptyState } from "./styled";

export const TableEmpty = () => {
  return <EmptyState>{intl.get("dailyDelivery.emptyDataDailyDelivery")}</EmptyState>;
};
